// Tiny merge-field engine for email templates.
// Tokens look like {{contact.firstName}} or {{user.name}}.
// Missing tokens are replaced with empty string (not left as literal).

export interface MergeContext {
  contact?: Record<string, any>;
  account?: Record<string, any>;
  deal?: Record<string, any>;
  user?: Record<string, any>;
}

export function applyMerge(tpl: string, ctx: MergeContext): string {
  return tpl.replace(/\{\{\s*([a-zA-Z_][\w.]*)\s*\}\}/g, (_, path: string) => {
    const parts = path.split(".");
    let v: any = ctx;
    for (const p of parts) {
      if (v === undefined || v === null) return "";
      v = v[p];
    }
    return v === undefined || v === null ? "" : String(v);
  });
}

/** Derive helpful synthetic fields from a contact record. */
export function enrichContactForMerge(contact: any): Record<string, any> {
  if (!contact) return {};
  const firstName = contact.firstName ?? contact.name?.split(" ")[0] ?? "";
  const lastName  = contact.lastName  ?? contact.name?.split(" ").slice(1).join(" ") ?? "";
  return {
    ...contact,
    firstName,
    lastName,
    fullName: contact.name ?? `${firstName} ${lastName}`.trim(),
  };
}

/** Catalog of tokens to show in a "Insert merge field" dropdown. */
export const AVAILABLE_TOKENS = [
  { label: "Contact first name", token: "{{contact.firstName}}" },
  { label: "Contact last name",  token: "{{contact.lastName}}" },
  { label: "Contact full name",  token: "{{contact.fullName}}" },
  { label: "Contact title",      token: "{{contact.title}}" },
  { label: "Contact email",      token: "{{contact.email}}" },
  { label: "Account name",       token: "{{account.name}}" },
  { label: "Account industry",   token: "{{account.industry}}" },
  { label: "Account website",    token: "{{account.website}}" },
  { label: "Deal name",          token: "{{deal.name}}" },
  { label: "Deal stage",         token: "{{deal.stage}}" },
  { label: "Sender name",        token: "{{user.name}}" },
  { label: "Sender email",       token: "{{user.email}}" },
];
